import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_LIEFERANTENSTAMM_PRODUKTGRUPPE } from '../lieferantenstamm.api';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierProductGroup } from '../types/supplier-product-group';

@Injectable()
export class LieferantenProduktgruppeRepository extends ReadonlyHttpApiListRepository<
  Result<SupplierProductGroup[]>,
  LieferantenQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_PRODUKTGRUPPE);
  }

  override getLoadPathParams(params: LieferantenQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
